import { render, staticRenderFns } from "./SelectGrades.vue?vue&type=template&id=2d517176&scoped=true"
import script from "./SelectGrades.vue?vue&type=script&lang=js"
export * from "./SelectGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d517176",
  null
  
)

export default component.exports